import React from 'react';
import { useState, useRef, useEffect } from 'react';
import { app } from '../../firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComments, faTimes } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios'; 
import reports from '../../asset/data/reports'
import './Billbot.css'
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore'
import load from '../../asset/COMMB Loading (1).gif'
import logo from '../../asset/logo-dot-white@4x.png'
import send from '../../asset/Send.png'
import mode from '../../asset/day-and-night (1).png'
import sound from '../../asset/sound.png'
import darkSound from '../../asset/dark-sound.png'
import search from '../../asset/search-interface-symbol.png'
import bot_logo from '../../asset/bot_logo.png'
import up from '../../asset/like.png';

const BillbotChatBox = () => {
  const [messages, setMessages] = useState([]);
  const [pdfMessages, setpdfMessages] = useState([])
  const [userMessage, setUserMessage] = useState("");
  const [lang, setLang] = useState("EN")
  const [ttsEnabled, setTTSEnabled] = useState(false);
  const [allowTagClick, setAllowTagClick] = useState(true);
  const [typingIntervalId, setTypingIntervalId] = useState(null);
  const [timeStamp, setTimeStamp] = useState(null)
  const [ipAddress, setIpAddress] = useState(null);
  const [currentAudio, setCurrentAudio] = useState(null);
  const conversationRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const db = getFirestore(app);
  // ========================================
  // Section: Functions
  // ========================================

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const sendMessage = async () => {
    const sendButton = document.querySelector('.send-button');


    if (sendButton.classList.contains('inactive')) {
      return;
    }
    sendButton.classList.add('inactive')
  
    if (!userMessage) {
      return;
    }
    setAllowTagClick(false)
    setUserMessage("");
    const userMessageData = {
      msg_text: userMessage,
      type: 'user'
    };
    setMessages(prevMessages => [...prevMessages, userMessageData]);
    
    const url = lang === "FR" ? `https://api-4hbrtb4uja-uc.a.run.app/sendMsgToOpenAIfr` : 'https://api-4hbrtb4uja-uc.a.run.app/sendMsgToOpenAI'; 
    const response = await axios.post(url, {
      userMessage: 'current user message: ' + userMessage ,
    });

    const msg_index = messages.length
    if (response.status === 200) {
      const botMessage = lang === 'FR'
      ? response.data.generatedResponse + " Cliquez ci-dessous si vous souhaitez que je recherche davantage de résultats spécifiques dans la publication COMMB."
      : response.data.generatedResponse + " Click below if you would also like see relevant COMMB publication for more information.";
    
      if (botMessage) {
        const ttsMessage = botMessage.replace('COMMB', 'comb')
        handleTTS(ttsMessage);
      }
      const botMessageData = {
        msg_text: botMessage,
        type: 'bot',
        timestamp: serverTimestamp(),
        showFeedback: false,  
        feedbackGiven: false  
      };
      
      const messageData = {
        msg_user: userMessage,
        msg_bot_initial: botMessage,
        ip_address: ipAddress,
        timestamp: serverTimestamp()
      };
      await addDoc(collection(db, "messages"), messageData);
      setMessages(prevMessages => [...prevMessages, botMessageData]);
      let index = 0;
      const typingInterval = setInterval(() => {
        if (index < botMessage.length) {
          const botMessageWithTyping = botMessage.substring(0, index + 1);
          const updatedBotMessageData = {
            ...botMessageData,
            msg_text: botMessageWithTyping
          };
          setMessages(prevMessages => {
            const updatedMessages = [...prevMessages];
            updatedMessages[prevMessages.length - 1] = updatedBotMessageData;
            return updatedMessages;
          });
          index++;
        } else {
          clearInterval(typingInterval);
          setMessages(prevMessages => {
            const updatedMessages = [...prevMessages];
            updatedMessages[prevMessages.length - 1].showFeedback = true; 
            return updatedMessages;
          });
          setAllowTagClick(true);
          sendButton.classList.remove('inactive');
          const btn = document.querySelector(`button#btn${messages.length+1}`);
          if (btn) {
            btn.classList.remove('hide');
            btn.classList.add('fade-in');
          } else {
            console.log(false);
          }
        }
      }, 15);
      setTypingIntervalId(typingInterval);
    } else {
      console.error('Error getting intial response.');
    }      
    handlePDFResponse(response, msg_index);
  };

  const handleFeedback = async (msg, feedbackType, index) => {
    try {
      await addDoc(collection(db, "feedback"), {
        msg_text: messages[index] || "",
        feedback: feedbackType,
        timestamp: serverTimestamp(),
        ip_address: ipAddress || "", 
        user_msg: messages[index - 1] || "",  
        paraphrased_response: pdfMessages[index]?.msg_text || "", 
        pdf_files: pdfMessages[index]?.msg_urls || []
      });
  
      setMessages(prevMessages => {
        return prevMessages.map(message => {
          if (message === msg) {
            return {
              ...message,
              feedbackGiven: true  
            };
          }
          return message;
        });
      });
    } catch (error) {
      console.error('Error sending feedback: ', error);
    }
  };

  const handlePDFResponse = async (response, msg_index) => {
    const pdfUrl = 'https://api-4hbrtb4uja-uc.a.run.app/rag' 
    const requestData = {
      query: userMessage,
      filter: { language: "en-US" }
    };
  
    const headers = {
      'Content-Type': 'application/json'
    };
  

    const pdfResponse = await fetch(pdfUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(requestData)
    });
    if (pdfResponse.status === 200) {
      const responseData = await pdfResponse.json();
      console.log(responseData);
      handleParaphrase(responseData, userMessage, response, msg_index)
    } else {
      console.error('Error getting seaplane response.');
    }
  }

  const handleParaphrase = async (pdfResponse, userMessage, response, msg_index) => {
    const url = lang === "FR" ? `https://api-4hbrtb4uja-uc.a.run.app/paraphraseOpenAI/fr` : 'https://api-4hbrtb4uja-uc.a.run.app/paraphraseOpenAI'; 
    const paraphraseResponse = await axios.post(url, {
      userMessage:  'user query: ' + userMessage + ' 1st response: ' + response.data.generatedResponse + ' 2nd response: ' + pdfResponse.response,
    });

    if (paraphraseResponse.status=== 200) {
      const updatedBotMessageData = {
        msg_text: paraphraseResponse.data.generatedResponse ,
        msg_urls: pdfResponse.sources,
        msg_titles: pdfResponse.filenames
      };
      setpdfMessages(prevMessages => {
        const updatedMessages = { ...prevMessages };
        updatedMessages[msg_index + 1] = updatedBotMessageData;
        return updatedMessages;
      });
      const messageData = {
        msg_user: userMessage,
        msg_bot_seaplane: pdfResponse.response,
        msg_bot_files: pdfResponse.filenames,
        msg_bot_paraphrased: paraphraseResponse.data.generatedResponse,
        ip_address: ipAddress,
        timestamp: serverTimestamp()
      };
      await addDoc(collection(db, "messages"), messageData);
    } else {
      console.error('Error getting paraphrase response.');
    }
  }

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    fetchIpAddress();
  }, []);
  
  const handleKeyDown = (e) => {
    if (allowTagClick && userMessage && e.key === 'Enter') {
      sendMessage()
    }
  }

  const scrollToBottom = () => {
    if (conversationRef.current) {
      conversationRef.current.scrollTop = conversationRef.current.scrollHeight;
    }
  };

  const toggleTTS = () => {
    setTTSEnabled(!ttsEnabled);
  }

  const handleTTS = async (text) => {
    if (!ttsEnabled) return;
    text = text.replace(/COMMB/g, 'comb')
    text = text.replace(/OOH/g, 'O O H')
    try {
      const response = await fetch('https://api-4hbrtb4uja-uc.a.run.app/synthesize', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ text }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to generate speech');
      }
  
      const audioBlob = await response.blob();
      const audioUrl = URL.createObjectURL(audioBlob);
      const newAudio = new Audio(audioUrl);
      setCurrentAudio(false)
      if (currentAudio) {
        currentAudio.pause();
      }
      setCurrentAudio(newAudio);
      newAudio.play();  
      newAudio.addEventListener('ended', () => {
        setCurrentAudio(null);
      });
    } catch (error) {
      console.error('Error:', error.message);
    }
  };

  const removeHideClass = (index) => {
    const target = document.querySelector(`.pdf-query-${index}`);
    if (target) {
      target.classList.remove('hide');
      const btn = document.querySelector(`button#btn${index}`);
      if (btn) {
        btn.classList.add('hide');
      } else {
        console.error('unable to find btn')
      }
    } else {
      console.error('unable to find target')
    }
  };
  
  const handlePDFSearch = (e) => {
    const btn = e.target.closest('button');
    btn.querySelector('p').classList.add('hide');
    const img = btn.querySelector('img');
    img.style.opacity = 1;
    const msg_id = parseInt(btn.id.replace('btn', ''), 10);
    btn.querySelector('.pdf-load').classList.remove('hide');
    const intervalId = setInterval(() => {
    removeHideClass(msg_id);
      const target = document.querySelector(`.pdf-query-${msg_id}`);
      if (target) {
        clearInterval(intervalId);
      }
    }, 1000);
    setTimeout(() => {
      clearInterval(intervalId);
    }, 10000);
  };
  

  // ========================================
  // Section: Effects
  // ========================================

  useEffect(() => {
    return () => {
      clearInterval(typingIntervalId);
    };
  }, [typingIntervalId]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);


  useEffect(() => {
    const now = new Date();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const day = days[now.getDay()];
    const hours = now.getHours() % 12 || 12; 
    const minutes = now.getMinutes();
    const amPm = now.getHours() >= 12 ? 'PM' : 'AM';
    const formattedTimestamp = `${day} ${hours}:${minutes < 10 ? '0' + minutes : minutes} ${amPm}`;
    setTimeStamp(formattedTimestamp);
  }, []);



  // ========================================
  // Section: JSX Structure
  // ========================================

  return (
    <div className="chatbox-container">
      {isOpen ? (
        <div className='chatbot'>
          <div className={`chatbox ${darkMode ? 'dark' : ''}`}>
            <div className="header">
              <img src={logo} alt="" />
              <div className="toggle-lang">
                <span className={lang === 'EN' ? 'selected' : ''} onClick={() => {setLang('EN')}}>EN</span>
                <span>|</span>
                <span className={lang === 'FR' ? 'selected' : ''} onClick={() => {setLang('FR')}}>FR</span>
                <button className="close-btn" onClick={handleToggle}>
                  <FontAwesomeIcon icon={faTimes} className='icon' size="1x" />
                </button>
              </div>
    
            </div>
            <div className='fixed'>
              <div className="timestamp">
                {timeStamp}
              </div>
              <div className="toggle-tts">
                <img src={darkMode ? darkSound : sound} alt="" />
                <div>            
                  <input checked={ttsEnabled} onChange={toggleTTS} type="checkbox" id='tts' onClick={(e) => e.stopPropagation()}/>
                  <label htmlFor="tts" className='button'></label>
                </div>
              </div>
            </div>
            <div className="conversation" ref={conversationRef}>
              <div className='bot'>
                {lang === 'EN' ? 'Hello, my name is BillBot, and I can answer questions about OOH. How can I help you?' :"Bonjour, je m'appelle BillBot, et je peux répondre aux questions sur les affichages extérieurs. Comment puis-je vous aider?"}
              </div>
              {messages.map((msg, index) => (
                <div key={index} className={msg.type} >
                  <p>{msg.msg_text}</p>
                  {msg.type === 'bot' && (
                      <button id={"btn" + index} className={`pdf-btn hide`} onClick={handlePDFSearch}><img src={load} className='pdf-load hide' alt="" /><p className='slide'><img src={search} alt="" />{lang === 'EN'?'Click to search':"Rapport d'analyse"}</p>
                      </button>
                  )}

                  {msg.type === 'bot' && pdfMessages[index] && (
                    <p className={`pdf-query-${index} hide`}>
                      {lang === "FR" ? "Voici ce que j'ai trouvé en lisant les publications de COMMB. " : "Here is what I found reading through COMMB publications. "}{pdfMessages[index].msg_text}{lang === "FR" ? " Vous pouvez trouver plus d'informations dans :":" You can find more information in: "}{' '}
                      {pdfMessages[index].msg_titles.split(',').map((filename, i) => {
                          const matchingReport = reports.find(report => report.filename === filename);
                          if (matchingReport) {
                            return (
                              <a
                                key={i}
                                className={`pdf-link ${darkMode ? 'dark-mode' : ''}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={pdfMessages[index].msg_urls.split(',')[i]}
                              >
                                {matchingReport.title}
                              </a>
                            );
                          } else {
                  
                            return (
                              <a
                                key={i}
                                className={`pdf-link ${darkMode ? 'dark-mode' : ''}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={pdfMessages[index].msg_urls.split(',')[i]}
                              >
                                {filename}
                              </a>
                            );
                          }
                      })}
                    </p>
                  )}

                  {msg.type === 'bot' && msg.showFeedback && (
                    <div className="feedback">
                      <span>
                        {msg.feedbackGiven ? "Thank you for your feedback." : "How would you rate BillBot's response?"}
                      </span>
                      {!msg.feedbackGiven && (
                        <div className="icons">
                          <div onClick={() => handleFeedback(msg, 'up', index)}>
                            <img src={up} alt="Thumbs up" />
                          </div>
                          <div onClick={() => handleFeedback(msg, 'down', index)}>
                            <img src={up} className='down' alt="Thumbs down" />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div className="user-input">
              <img src={mode} onClick={() => setDarkMode(!darkMode)}  alt=''/>
              <input
                placeholder={lang === 'EN'? 'Type your message here...' : 'Tapez votre message ici..'}
                value={userMessage}
                onChange={e => setUserMessage(e.target.value)}
                onKeyDown={handleKeyDown}
              />
              <button onClick={sendMessage} className='send-button'><img src={send} alt="" /></button>
            </div>
          </div>    
        </div>
          ) : (
            <div className="chatbox-icon" onClick={handleToggle}>
              <img src={bot_logo} alt="" />
            </div>
          )}
    </div>
  );
}

export default BillbotChatBox